import { module } from 'stereomodularjs';
import {Swiper, Navigation, Scrollbar } from 'swiper';
// Import navigation module from swiper


export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.swiper = new Swiper(this.el, {
            // Add gap
            // spaceBetween: 6,
            slidesPerView: 'auto',
            modules: [Scrollbar],
            scrollbar: {
                el: '.swiper-scrollbar',
                dragSize: 78,
                draggable: true,
            },
            
        
        });
        
       
        
    }
}
 